import { FetchOptions, HttpMethod } from './interfaces/gopher-buddy-api.interfaces';

import { environment } from '../../../environments/environment';
import { ExtensionCheckinResponse } from '../check-in/check-in.interfaces';
import UtilsService from '../utils/utils.service';

const getFetch = <ReturnType = unknown>(fetchOptions: FetchOptions): Promise<ReturnType> => {
  UtilsService.debugLog(`GopherBuddyApiService.fetch`, fetchOptions);

  const { apiToken, apiServer } = environment;
  let fullUrl = `${apiServer}${fetchOptions.url}?apiToken=${apiToken}`;
  if (fetchOptions.queryParameters !== undefined) {
    Object.entries(fetchOptions.queryParameters).forEach(([key, value]) => {
      fullUrl += `&${key}=${value}`;
    });
  }
  const headers = {
    'Content-Type': 'application/json',
  };
  return fetch(fullUrl, {
    method: fetchOptions.method,
    headers,
  }).then((response) => response.json() as ReturnType);
};

const GopherBuddyApiService = {
  CheckIn: {
    get: async (domain: string, deviceId: string, email: string): Promise<ExtensionCheckinResponse> =>
      getFetch<ExtensionCheckinResponse>({
        url: `/check-in`,
        method: HttpMethod.GET,
        queryParameters: { domain, deviceId, email },
      }),
  },
};

export default GopherBuddyApiService;
